import Popover from "../Popover";
import { RiArrowRightLine, RiEyeLine } from "react-icons/ri";

import {
  ActionItem,
  ActionsContainer,
  Container,
  Header,
  IconButtonContainer,
  LeftContent,
  MiddleContent,
  PrincipalInfos,
  RightContent,
  ValueContainer,
} from "./styles";
import { useEffect, useState } from "react";
import ReactDynamicFont from "react-dynamic-font";
import { BiDollar } from "react-icons/bi";
import { i18n } from "../../localization/i18n";
import { Bill } from "../../hooks/AuthContext";
import { MdSync } from "react-icons/md";
import { currencyValue } from "../UsersProfile/mock";
import BillDetailsModal from "../BillDetaisModal";

interface IClosureItem {
  title: string;
  description: string;
  help?: string;
  value: string | number;
  onClick?: () => void;
  period?: string;
  acceptPayment?: boolean;
  onHandlePayBill?: () => void;
  bill?: Bill;
  closurePeriod?: Date;
  currency?: string;
}

export function ClosureItem({
  title,
  description,
  help,
  value,
  onClick,
  period,
  acceptPayment,
  onHandlePayBill,
  bill,
  closurePeriod,
  currency,
}: IClosureItem) {
  const [formatedValue, setFormatedValue] = useState<string[]>([]);
  const [modalIsOpen, setModalIsOpen] = useState(false)

  function toggleOpenModal() {
    setModalIsOpen(!modalIsOpen)
  }

  useEffect(() => {
    const arr = value.toString().split(".");
    setFormatedValue(arr);
  }, [value]);

  return (
    <>
      <BillDetailsModal bill={bill} currencyCode={currency} period={period} isOpen={modalIsOpen} onRequestClose={toggleOpenModal} />
      <Container>
        <Header>
          <LeftContent>
            <ValueContainer
              paymentPending={
                acceptPayment && value > 0
                  ? "not_paid"
                  : bill && !bill.payment_date
                    ? "pending"
                    : "paid"
              }
            >
              <ReactDynamicFont content={formatedValue[0]} />
              {formatedValue[1] && <div>.{formatedValue[1]}</div>}
            </ValueContainer>
            <PrincipalInfos
              paymentPending={
                acceptPayment && value > 0
                  ? "not_paid"
                  : bill && !bill.payment_date
                    ? "pending"
                    : "paid"
              }
            >
              <span className="solution">{title}</span>
              <span className="date">
                {description}
                <br />
                {period}
              </span>
            </PrincipalInfos>
          </LeftContent>
          {help && (
            <RightContent>
              <ActionsContainer>
                {/* Lógica do SEU branch para o botão de pagar */}
                {/*  {acceptPayment &&
                  value > 0 &&
                  closurePeriod &&
                  new Date(
                    closurePeriod?.getFullYear(),
                    closurePeriod?.getMonth() + 1,
                    0
                  ) <= new Date() && (
                    <ActionItem>
                      <Popover position="left" label={`${i18n.t("bills.pay")}`}>
                        <IconButtonContainer>
                          <BiDollar size={18} onClick={onHandlePayBill} />
                        </IconButtonContainer>
                      </Popover>
                    </ActionItem>
                  )}

                */}
                {/* Lógica do OUTRO branch para alterar método de pagamento */}
                {currency === currencyValue.BRL &&
                  !bill?.payment_date &&
                  bill?.payment_method === "fixcoin" &&
                  bill.payment_situation !== "pago" && (
                    bill.payment_situation !== "PAYMENT_RECEIVED" &&
                    <ActionItem>
                      <Popover
                        position="left"
                        label={`${i18n.t("bills.completePayment")}`}
                      >
                        <IconButtonContainer>
                          <BiDollar size={18} onClick={onHandlePayBill} />
                        </IconButtonContainer>
                      </Popover>
                    </ActionItem>
                  )
                }

                {bill &&
                  <ActionItem>
                    <Popover
                      position="left"
                      label={`${i18n.t("orders.view")}`}
                    >
                      <IconButtonContainer>
                        <RiEyeLine size={18} onClick={toggleOpenModal} />
                      </IconButtonContainer>
                    </Popover>
                  </ActionItem>
                }
                <ActionItem>
                  <Popover position="left" label={help}>
                    <IconButtonContainer>
                      <RiArrowRightLine size={18} onClick={onClick} />
                    </IconButtonContainer>
                  </Popover>
                </ActionItem>
              </ActionsContainer>
            </RightContent>
          )}
        </Header>
      </Container>
    </>
  );
}
